"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var escapeHtml_1 = require("../tools/escapeHtml");
var TEMPLATE = ''.concat('<li data-key="{{key}}" data-url="{{url}}">', '<span>{{content}}</span>', '</li>');
var CONTENT_TEMPLATE = '<span class="key">{{key}}</span>';
var ListWidget = (function (_super) {
    __extends(ListWidget, _super);
    function ListWidget(node, config) {
        var _this = _super.call(this, node, config) || this;
        _this.readOnly = false;
        return _this;
    }
    ListWidget.prototype.dataConfig = function () {
        return ['addurl', 'deleteurl', 'param'];
    };
    ListWidget.prototype.defaultConfig = function () {
        return {
            slideTime: 250,
            eventNS: 'list-widget'
        };
    };
    ListWidget.prototype.init = function () {
        this.input = this.el.find('input');
        this.primary = this.el.find('ul:first-of-type');
        this.secondary = this.el.find('ul.secondary');
        this.el.on('submit', 'form', jquery_1.default.proxy(this.handleSubmit, this));
        this.el.on('click', '.delete', jquery_1.default.proxy(this.handleDeleteClick, this));
        this.config.contentTemplate = this.getContentTemplate();
        this.updateHasPrimaryItems();
        this.updateHasSecondaryItems();
        this.readOnly = this.el.hasClass('read-only');
    };
    ListWidget.prototype.getContentTemplate = function () {
        var candidates = this.el.find("script[type='text/template']");
        if (candidates.length === 1) {
            return candidates.html();
        }
        else {
            return CONTENT_TEMPLATE;
        }
    };
    ListWidget.prototype.handleAdd = function (e, data) {
        if (this.readOnly) {
            return;
        }
        data = typeof data === "string" ? { key: data } : data;
        this.remove(data.key);
        this.add(data);
    };
    ListWidget.prototype.handleDelete = function (e, data) {
        if (this.readOnly) {
            return;
        }
        this.remove(typeof data === "string" ? data : data.key);
    };
    ListWidget.prototype.handleSubmit = function (e) {
        var _this = this;
        e.preventDefault();
        var key = jquery_1.default.trim(this.input.val());
        var sendData;
        if (this.readOnly || !key) {
            return;
        }
        sendData = {};
        sendData[this.config.param] = key;
        this.send(this.config.addurl, sendData, function (response) {
            if (response.success) {
                _this.remove(key);
                _this.add({ key: key });
                _this.notify('added', key);
            }
        });
        this.input.val('');
    };
    ListWidget.prototype.handleDeleteClick = function (e) {
        var _this = this;
        if (this.readOnly) {
            return;
        }
        var listItem = jquery_1.default(e.target).closest('li');
        var data = ListWidget.getData(listItem);
        var sendData = {};
        sendData[this.config.param] = escapeHtml_1.unescapeHtml(data.key);
        listItem.addClass('pending');
        this.send(this.config.deleteurl, sendData, function (response) {
            if (response.success) {
                _this.remove(data.key);
                _this.notify('deleted', data);
            }
        }).always(function () {
            listItem.removeClass('pending');
        });
    };
    ListWidget.prototype.send = function (url, data, callback) {
        if (this.readOnly) {
            return;
        }
        return jquery_1.default.ajax({
            cache: false,
            url: url,
            method: 'POST',
            format: 'json',
            context: this,
            data: data
        }).done(callback);
    };
    ListWidget.prototype.getHtml = function (model) {
        var content = this.config.contentTemplate;
        var name, regex, html;
        for (name in model) {
            if (model.hasOwnProperty(name)) {
                regex = new RegExp("\\{\\{" + name + "\\}\\}", "g");
                content = content.replace(regex, escapeHtml_1.escapeHtml(model[name]));
            }
        }
        html = TEMPLATE.replace(/\{\{content}}/g, content).replace(/\{\{key}}/g, escapeHtml_1.escapeHtml(model.key.toLowerCase()));
        if (typeof (model.url) != "undefined") {
            html = html.replace(/\{\{url}}/g, escapeHtml_1.escapeHtml(model.url));
        }
        return html;
    };
    ListWidget.prototype.getListingsBykey = function (key) {
        var items = this.el.find('li[data-key]');
        var index = items.length;
        var result = [];
        while (index--) {
            if (typeof (key) != "undefined" && items[index].getAttribute('data-key').toLowerCase() == key.toLowerCase()) {
                result.unshift(items[index]);
            }
        }
        return jquery_1.default(result);
    };
    ListWidget.prototype.updateHasPrimaryItems = function () {
        this.el.toggleClass('has-items', !!this.primary.children().length);
    };
    ListWidget.prototype.updateHasSecondaryItems = function () {
        this.el.toggleClass('has-secondary', !!this.secondary.children().length);
    };
    ListWidget.prototype.add = function (model) {
        var _this = this;
        if (typeof (model.key) == "undefined" || this.readOnly) {
            this.notify('addFinished', model);
            return;
        }
        var listItem = jquery_1.default(this.getHtml(model)).hide();
        this.primary.prepend(listItem);
        listItem.slideDown(this.config.slideTime);
        this.resolveOverflow();
        this.updateHasSecondaryItems();
        this.updateHasPrimaryItems();
        setTimeout(function () {
            _this.notify('addFinished', model);
        }, this.config.slideTime);
    };
    ListWidget.prototype.remove = function (key) {
        var _this = this;
        if (this.readOnly) {
            return;
        }
        var listItem = this.getListingsBykey(key);
        listItem.slideUp(this.config.slideTime, function () {
            listItem.remove();
            _this.resolveOverflow();
            _this.updateHasSecondaryItems();
            _this.updateHasPrimaryItems();
            setTimeout(function () {
                _this.notify('removeFinished', key);
            }, _this.config.slideTime);
        });
    };
    ListWidget.getData = function (node) {
        return {
            title: node.attr("data-title"),
            key: node.attr("data-key"),
            date: node.attr("data-date"),
            url: node.attr("data-url")
        };
    };
    ListWidget.prototype.resolveOverflow = function () {
        var primaryItems = this.primary.children();
        var secondaryItems = this.secondary.children();
        var primaryLength = primaryItems.length;
        if (primaryLength > 5) {
            primaryItems.slice(5).prependTo(this.secondary);
        }
        else if (primaryLength < 5 && secondaryItems.length) {
            secondaryItems.slice(0, 5 - primaryLength).appendTo(this.primary);
        }
        this.el.toggleClass('no-secondary', !this.secondary.children().length);
    };
    ListWidget.prototype.notify = function (action, data) {
        var event = [this.config.eventNS, action].join('.');
        Widget_1.Widget.getBus().notify(event, data);
    };
    return ListWidget;
}(Widget_1.Widget));
exports.ListWidget = ListWidget;
